import o from "styled-components";
import n from "../../Icons/Tick.js";
import t from "../../../utils/colors.js";
import { device as i } from "../../../utils/device.js";
const r = o.div``, l = o(r)`
  @media ${i.isDesktop} {
    margin-right: 64px;
  }

  @media ${i.isMobile}, ${i.isTablet} {
    border-bottom: solid 1px ${t.blueGrey25};
  }
`, x = o(r)`
  @media ${i.isDesktop} {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`, m = o(r)`
  position: relative;

  @media ${i.isDesktop} {
    display: flex;
    align-self: flex-start;
    left: 40px;
    padding-top: 37px;
    height: ${(e) => `${e.height}px;`};
  }

  @media ${i.isMobile}, ${i.isTablet} {
    top: 36px;
    left: 20px;
    right: 20px;
    width: calc(100% - 40px);
  }
`, c = o(r)`
  border: solid 1px ${t.orange};
`, g = o.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  border-radius: 2px;
  background-color: ${t.white};

  @media ${i.isDesktop} {
    border: solid 1px ${t.orange};
    width: 200px;
    margin-top: 0px;
    padding: 32px 20px 40px 20px;
  }

  @media ${i.isMobile}, ${i.isTablet} {
    flex-direction: row;
    padding-left: 20px;
    padding-right: 20px;
    justify-content: space-between;
    align-items: center;
  }
`, h = o.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  @media ${i.isDesktop} {
    margin-bottom: 33px;
  }
`, f = o(r)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  min-height: 32px;
  border: solid 2px ${t.orange};
  border-radius: 100px;
  font-size: 19px;
  z-index: 2;
  color: ${t.white};
  font-weight: bold;
  background-color: ${(e) => e.mode === "Current" || e.mode === "Past" ? t.orange : t.white};
  color: ${(e) => e.mode === "Current" || e.mode === "Past" ? t.white : t.orange};
`, $ = o(n)`
  width: 20px;
  height: 20px;
`, b = o(r)`
  white-space: pre-wrap;
  word-break: break-word;
  overflow: hidden;
  margin-left: 12px;
  letter-spacing: -0.3px;
  line-height: 22px;
  max-height: 44px;
  min-height: 22px;
  color: ${(e) => e.mode === "Current" ? t.orange : t.blueGrey};
  font-weight: ${(e) => e.mode === "Current" ? "bold" : "600"};
  font-size: ${(e) => e.mode === "Current" ? "19px" : "1.1rem"};

  @media ${i.isMobile}, ${i.isTablet} {
    display: none;
  }
`;
export {
  x as Box,
  $ as CompletedStepWrapper,
  f as IconWrapper,
  h as ItemContainer,
  g as ListContainer,
  c as StepLine,
  m as StepsLineContainer,
  b as TextWrapper,
  l as Wrapper
};
